<template>
  <div ref="word" v-if="animation && width > 0" class="word word--counter">
    <span v-for="number, key in word" :class="{'word--counter-wrap': isNumber(number)}">
      <span :class="['word--counter-number', {'word--counter-number-animated': animation && animated}, {'word--counter-number-disable': counterStory[key] === 0}]" :style="`transition-duration: ${speed}ms; transform: translate3d(0,${isNumber(number) ? countNum(number) : textPad()}px,0)`">
        <span v-if="isNumber(number)" class="word--counter-num" v-for="count, sort in numbers">
          {{ count }}
        </span>
        <span v-else-if="sort === 0" :style="`transform: translate3d(0,${checkText(number)}px,0)`" class="word--counter-num word--counter-text" >{{ number }}</span>
      </span>
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: ['word', 'delay', 'speed', 'counter'],

  computed: mapGetters({
    animation: 'animation',
    theme: 'theme',
  }),

  watch: {
    theme() {
      this.startAnimation();
    },
  },

  data() {
    return {
      numbers: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 0],
      animated: false,
      timer: null,
      step: 0,
      countWord: 0,
      counterStory: [],
      width: 0,
    };
  },

  mounted() {
    this.calcWidth();
    window.addEventListener('resize', this.calcWidth);
    setTimeout(() => {
      this.animated = true;
      this.startAnimation();
    }, this.delay);
  },

  beforeDestro() {
    window.removeEventListener('resize', this.calcWidth);
  },

  methods: {
    startAnimation() {
      clearInterval(this.timer);
      this.animated = false;
      setTimeout(() => {
        this.animated = true;
      }, this.delay / 3);
    },
    calcWidth() {
      this.width = window.innerWidth;
    },
    isNumber(string) {
      return string.length && string.match(/^\d+$/);
    },
    countNum(number) {
      const numberH = this.width >= 1200 ? 52 : 36;
      if (number && this.animated) {
        return -number * numberH;
      }
      return this.animated ? 0 : numberH;
    },
    checkText() {
      const numberH = this.width > 1200 ? -52 : -36;
      return this.animated ? numberH : 6;
    },
    textPad() {
      return 52;
    },
  },
};
</script>

<style>

.word{
  &--counter{
    display: inline-block;

    &-wrap{
      display: inline-block;
      overflow: hidden;
      height: 54px;
      margin: 0;

      @media (max-width: $mediaIpad) {
        margin: 10px 0 0;
        height: 33px;
      }
    }

    &-number{
      .in-viewport &{
        transition: all .1s ease-in-out;
      }
      display: inline-block;
      min-width: 8px;

      &-animated{
         .in-viewport &{
          transition: all .3s ease-in-out;
        }
        opacity: 1;
      }
    }
    &-num{
      font-size: 47.5px;
      display: block;
      @media (max-width: $mediaIpad) {
        font-size: 33px;
      }
    }
    &-text{
      position: relative;
      display: block;
      top: 0;
      @media (max-width: $mediaIpad) {
        top: -10px;
      }
      .in-viewport & {
        transition: all 1s ease-in-out;
      }
    }
  }  
}

</style>



// WEBPACK FOOTER //
// src/components/TextPercentAnimation.vue